import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateChild } from '@angular/router';
import { ConfigurationService } from './configurationService';

@Injectable()
export class RouteGuardService implements CanActivate, CanActivateChild {
  constructor(public router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.isAllowed(state);
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.isAllowed(state);
  }

  isAllowed(state: RouterStateSnapshot): boolean {
    const prohibitedRoutes = ConfigurationService.appConfig.routeSecurity?.prohibitedRoutes || [];
    if (prohibitedRoutes.find((prohibitedRoute) => state.url.includes(prohibitedRoute))) {
      this.router.navigate([ConfigurationService.appConfig.routeSecurity.redirectTo]);
      console.log('Route forbidden: redirected.');
      return false;
    } else {
      return true;
    }
  }
}
